import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../slices/auth/login/action";
import { Navigate } from "react-router-dom";
import { ROUTE_USER_LOGIN } from "../../../constants/route";
// import withRouter from "../../Components/Common/withRouter";

const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutUser());
  }, [dispatch]);
  return <Navigate to={ROUTE_USER_LOGIN} />;
};
export default Logout;
